import React from 'react'

const Zapier = () => {
  return (
    <div className="page-wrapper">
      <div className="content">
Zapier
      </div>
      </div>
  )
}

export default Zapier